const pad = (n: number) => String(n).padStart(2, "0");

/** Terminal clock: [SS:DD:ss] in the viewer's local time. */
export function clock(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "[--:--:--]";
  return `[${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}]`;
}

/** "şimdi", "2 dk", "3 sa", "dün", "4 gün", then a short date. */
export function ago(iso: string, now = Date.now()): string {
  if (Number.isNaN(new Date(iso).getTime())) return "";
  const s = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (s < 45) return "şimdi";
  const m = Math.round(s / 60);
  if (m < 60) return `${m} dk`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} sa`;
  const d = Math.round(h / 24);
  if (d === 1) return "dün";
  if (d < 7) return `${d} gün`;
  return new Date(iso).toLocaleDateString("tr-TR", { day: "numeric", month: "short" });
}

export const formatCount = (n: number): string => n.toLocaleString("tr-TR");
